import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { type Platform, PlatformEnum } from "~/types/platform";

import * as Styled from "./TradeBonus.styles";

const KALSHI_REWARD_USD = 25;

const KALSHI_TOOLTIP = `Get a $${KALSHI_REWARD_USD} credit when you sign up here and deposit $100 or more.`;
const iconStyles = { fontSize: "11px", marginLeft: "2px", flexShrink: 0 };

interface ITradeBonusProps {
  platform: Platform;
}

export const TradeBonus: FC<ITradeBonusProps> = ({ platform }) => {
  if (platform === PlatformEnum.KALSHI) {
    return (
      <Styled.Root component="span" variant="caption" sx={{ fontSize: "11px" }}>
        Join Kalshi and score ${KALSHI_REWARD_USD} for your first trade.
        <RichTooltip title={KALSHI_TOOLTIP}>
          <InfoOutlinedIcon color="disabled" sx={iconStyles} />
        </RichTooltip>
      </Styled.Root>
    );
  }

  return null;
};
